module.exports = __webpack_public_path__ + "sagittarius-0c9a0cd34b0b48e58dfa.png";